import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, isRef as _isRef, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/wash-mark.png'


const _withScopeId = n => (_pushScopeId("data-v-8874ebfa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wash-tip" }
const _hoisted_2 = { class: "wash-tip-title" }
const _hoisted_3 = { class: "wash-tip-text" }
const _hoisted_4 = { class: "wash-tip-text-main" }
const _hoisted_5 = { class: "wash-tip-text" }
const _hoisted_6 = { class: "wash-tip-text-main" }
const _hoisted_7 = {
  class: "wash-tip-text",
  style: {"padding-bottom":"32px"}
}
const _hoisted_8 = { class: "wash-tip-text-main" }
const _hoisted_9 = {
  key: 0,
  class: "preview-img"
}
const _hoisted_10 = ["src", "width"]
const _hoisted_11 = { class: "wash-link" }
const _hoisted_12 = { class: "goods-sku" }
const _hoisted_13 = { class: "title" }
const _hoisted_14 = { class: "goods-sku props" }
const _hoisted_15 = { class: "title" }
const _hoisted_16 = { class: "tip" }
const _hoisted_17 = { class: "goods-sku props" }
const _hoisted_18 = { class: "title" }
const _hoisted_19 = { class: "tip" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wash-mark-img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    referrerPolicy: "no-referrer",
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_21 = { class: "wash-input" }
const _hoisted_22 = {
  class: "wash-input-item",
  style: {"height":"56px"}
}
const _hoisted_23 = { class: "wash-input-item" }
const _hoisted_24 = {
  key: 0,
  class: "made-china"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wash-tip" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "wash-tip-title" }, "Points to Note"),
  /*#__PURE__*/_createElementVNode("div", { class: "wash-tip-text" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "wash-tip-text-main" }, " This product is washed independently when washing, will local heavy dirt first, after the whole garment washing, button or zipper clothing first button or zipper button or zipper, immersion time should be short, 2 minutes is preferred. ")
  ])
], -1))
const _hoisted_26 = { class: "wash-link" }
const _hoisted_27 = { class: "goods-sku" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "SKU：", -1))
const _hoisted_29 = { class: "goods-sku props" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "SIZE：M", -1))
const _hoisted_31 = { class: "tip" }
const _hoisted_32 = { class: "goods-sku props" }
const _hoisted_33 = { class: "title" }
const _hoisted_34 = { class: "tip" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wash-mark-img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    referrerPolicy: "no-referrer",
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "made-in" }, "MADE IN CHINA", -1))

import { ref, watch } from 'vue'
import { isD2C, isJA, isKO, useSite } from '@/store'
import { t } from '@/plugins/i18n'
import UploadImageLimit from '@/components/common/UploadImageLimit.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
    skuType: { type: null, required: true },
    isRotate: { type: null, required: true },
    washMark: { type: null, required: true },
    imageRatio: { type: null, required: true },
    editStatus: { type: null, required: false },
    changeEditStatus: { type: null, required: false },
    changeImage: { type: null, required: false },
    openCropperImage: { type: null, required: false },
    urlList: { type: null, required: true },
    isPreview: { type: null, required: true },
    productPropNames: { type: null, required: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_unref(isKO)())
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([{ active: __props.isRotate }, 'wash-left'])
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('注意事項')), 1),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)(
                '1.色物の場合は、洗濯時に多少色落ちすることがありますので、他の洗濯物との混入はお避け下さい。また、汗や湿った状態での摩擦により、色落ちが生じる恐れがあります。'
              )), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('2.洗濯後多少の縮みがあります。')), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)(
                '3.生成り、淡色製品には蛍光増白剤が入っていない洗剤をご使用下さい。'
              )), 1)
            ])
          ]),
          _createElementVNode("div", {
            class: "wash-image",
            onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
          }, [
            (__props.isPreview)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _withDirectives(_createElementVNode("img", {
                    src: __props.urlList[0],
                    height: 135,
                    width: __props.washMark.imageRatio===2?(135*16/9):135
                  }, null, 8, _hoisted_10), [
                    [_vShow, __props.urlList[0]]
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("span", {
              class: _normalizeClass([{ active: __props.isRotate }, 'text'])
            }, _toDisplayString(_unref(t)('对折')), 3)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(t)('客户商品sku')) + "：", 1),
            (!__props.editStatus.skuType)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "placeholder abs",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (__props.changeEditStatus('skuType')), ["stop"])),
                  style: {"width":"200px"}
                }, _toDisplayString(__props.skuType == 1
              ? _unref(t)('不使用客户商品sku')
              : __props.skuType == 2
              ? _unref(t)('使用客户商品sku')
              : __props.skuType == 3
              ? _unref(t)('使用客户商品sku')
              : _unref(t)('关联商品库填写')), 1))
              : _createCommentVNode("", true),
            (__props.editStatus.skuType)
              ? (_openBlock(), _createBlock(_component_el_select, {
                  key: 1,
                  modelValue: __props.skuType,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(skuType) ? (skuType).value = $event : null)),
                  style: {"width":"140px"},
                  class: "selectSku"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: _unref(t)('不使用客户商品sku'),
                      value: 1
                    }, null, 8, ["label"]),
                    (_unref(isD2C)())
                      ? (_openBlock(), _createBlock(_component_el_option, {
                          key: 0,
                          label: _unref(t)('使用客户商品sku'),
                          value: 2
                        }, null, 8, ["label"]))
                      : _createCommentVNode("", true),
                    (!_unref(isD2C)())
                      ? (_openBlock(), _createBlock(_component_el_option, {
                          key: 1,
                          label: _unref(t)('使用客户商品sku'),
                          value: 3
                        }, null, 8, ["label"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(t)('規格')) + "：M", 1),
            _createElementVNode("span", _hoisted_16, " (" + _toDisplayString(_unref(t)('示例')) + ") ", 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(t)('表地：綿100％')), 1),
            _createElementVNode("span", _hoisted_19, " (" + _toDisplayString(_unref(t)('示例')) + ") ", 1)
          ]),
          _hoisted_20,
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              (!__props.editStatus.companyName)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "placeholder",
                    onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (__props.changeEditStatus('companyName')), ["stop"]))
                  }, _toDisplayString(__props.washMark.companyName ? __props.washMark.companyName : ''), 1))
                : _createCommentVNode("", true),
              (__props.editStatus.companyName)
                ? (_openBlock(), _createBlock(_component_el_input, {
                    key: 1,
                    placeholder: _unref(t)('请填写会社名'),
                    modelValue: __props.washMark.companyName,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((__props.washMark.companyName) = $event)),
                    style: {"width":"250px","height":"56px"},
                    type: "textarea",
                    maxlength: "30",
                    class: "selectInput1"
                  }, null, 8, ["placeholder", "modelValue"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_23, [
              (!__props.editStatus.companyAddress)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "placeholder",
                    onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (__props.changeEditStatus('companyAddress')), ["stop"]))
                  }, _toDisplayString(__props.washMark.companyAddress
                ? __props.washMark.companyAddress
                : ''), 1))
                : _createCommentVNode("", true),
              (__props.editStatus.companyAddress)
                ? (_openBlock(), _createBlock(_component_el_input, {
                    key: 1,
                    type: "textarea",
                    rows: 2,
                    placeholder: _unref(t)('请填写会社地址'),
                    modelValue: __props.washMark.companyAddress,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((__props.washMark.companyAddress) = $event)),
                    style: {"width":"250px","height":"56px"},
                    maxlength: "50",
                    class: "selectInput2"
                  }, null, 8, ["placeholder", "modelValue"]))
                : _createCommentVNode("", true)
            ]),
            (!_unref(isD2C)() && _unref(isJA)())
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, "MADE IN CHINA"))
              : _createCommentVNode("", true)
          ])
        ], 2))
      : _createCommentVNode("", true),
    (_unref(isKO)())
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass([{ active: __props.isRotate }, 'wash-left ko'])
        }, [
          _hoisted_25,
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("span", {
              class: _normalizeClass([{ active: __props.isRotate }, 'text'])
            }, _toDisplayString(_unref(t)('对折')), 3)
          ]),
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            (!__props.editStatus.skuType)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "placeholder abs",
                  onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (__props.changeEditStatus('skuType')), ["stop"]))
                }, _toDisplayString(__props.skuType == 1
              ? _unref(t)('不使用客户商品sku')
              : __props.skuType == 2
              ? _unref(t)('使用客户商品sku')
              : __props.skuType == 3
              ? _unref(t)('使用客户商品sku')
              : _unref(t)('关联商品库填写')), 1))
              : _createCommentVNode("", true),
            (__props.editStatus.skuType)
              ? (_openBlock(), _createBlock(_component_el_select, {
                  key: 1,
                  modelValue: __props.skuType,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(skuType) ? (skuType).value = $event : null)),
                  style: {"width":"140px"},
                  class: "selectSku"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: _unref(t)('不使用客户商品sku'),
                      value: 1
                    }, null, 8, ["label"]),
                    (_unref(isD2C)())
                      ? (_openBlock(), _createBlock(_component_el_option, {
                          key: 0,
                          label: _unref(t)('使用客户商品sku'),
                          value: 2
                        }, null, 8, ["label"]))
                      : _createCommentVNode("", true),
                    (!_unref(isD2C)())
                      ? (_openBlock(), _createBlock(_component_el_option, {
                          key: 1,
                          label: _unref(t)('使用客户商品sku'),
                          value: 3
                        }, null, 8, ["label"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _createElementVNode("span", _hoisted_31, " (" + _toDisplayString(_unref(t)('示例')) + ") ", 1)
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("span", _hoisted_33, _toDisplayString(_unref(t)('QUA：cotton100％')), 1),
            _createElementVNode("span", _hoisted_34, " (" + _toDisplayString(_unref(t)('示例')) + ") ", 1)
          ]),
          _hoisted_35,
          _hoisted_36
        ], 2))
      : _createCommentVNode("", true)
  ]))
}
}

})